import axios from 'axios';
import { Helpers } from '../helpers/Helpers';

/**
 * Özel Günler (İnsan Kaynakları > Tanımlamalar, QR Mesai Faz 1b, 11.10.2026).
 * Resmi tatilde okutulan sürenin tamamı ek mesaidir; yarım günde çalışma bitişi o gün için değişir.
 */

export const OZEL_GUN_TURLERI = [
    { value: 1, label: 'Resmi tatil' },
    { value: 2, label: 'Yarım gün' },
];

export interface OzelGunItem {
    ozelGunId: string
    /** "yyyy-MM-dd" */
    tarih: string
    /** "dd.MM.yyyy" */
    tarihStr: string
    ad: string
    tur: number
    turAdi: string
    /** "HH:mm"; yalnız yarım günde. */
    yarimGunBitis: string | null
    /** Liste ekranında satır seçimi (yalnız ekranda). */
    isSelected?: boolean
}

export interface OzelGunKaydetIstegi {
    ozelGunId?: string | null
    tarih: string
    ad: string
    tur: number
    yarimGunBitis: string | null
}

interface Yanit<T> { isSuccess: boolean, message?: string, data: T }

const cagir = async <T>(uc: string, govde: any = {}): Promise<Yanit<T>> => {
    try {
        console.log('SERVICE CALL - OzelGun/' + uc, JSON.stringify(govde));
        const resp = await axios.post(Helpers.getEndpoint() + '/OzelGun/' + uc, govde);
        return Helpers.dataParser(resp);
    } catch (error) {
        throw Helpers.parseErrorMessage(error);
    }
}

export class OzelGunService {
    static getList = (yil: number) => cagir<OzelGunItem[]>('GetList', { yil });
    static kaydet = (istek: OzelGunKaydetIstegi) => cagir<OzelGunItem>('Kaydet', istek);
    static sil = (ids: string[]) => cagir<boolean>('Sil', { ids });
    /** Sabit tarihli resmi tatilleri (ve 28 Ekim yarım günü) ekler; eklenen sayıyı döner. */
    static resmiTatilleriYukle = (yil: number) => cagir<number>('ResmiTatilleriYukle', { yil });
}
